import React, { ReactNode } from 'react';
import { MarginBottomProps, MinHeightProps, PaddingProps } from 'styled-system';

import { FilestackImageData } from 'api/types/shared.types';
import { Box } from 'components/Box';
import { gutterWidth } from 'theme';

import { Banner, MobileBanner } from './Banner';

type StyleProps = Pick<PaddingProps, 'pt' | 'pb'> &
  MinHeightProps &
  Pick<MarginBottomProps, 'mb'>;

type Props = {
  heroImage: FilestackImageData;
  mobileHeroImage?: FilestackImageData;
  children: ReactNode;
  withOverlay?: boolean;
  withLightOverlay?: boolean;
  'data-qa-id'?: string;
} & StyleProps;

export function Hero({
  heroImage,
  mobileHeroImage,
  children,
  withOverlay,
  withLightOverlay,
  'data-qa-id': dataQaId,
  pt,
  pb,
  minHeight,
  mb,
}: Props) {
  const convert = !(heroImage && heroImage.mimetype === 'image/jpeg');

  return (
    <Box
      position="relative"
      display="flex"
      width={1}
      minHeight={minHeight || ['320px', null, null, '450px']}
      px={[gutterWidth / 2, null, null, gutterWidth]}
      py={[48, null, null, 96]}
      justifyContent="center"
      alignItems="center"
      color="white"
      data-qa-id={dataQaId}
      pt={pt}
      pb={pb}
      mb={mb}
    >
      <Box
        position="absolute"
        top={0}
        left={0}
        width={1}
        height="100%"
        overflow="hidden"
      >
        {(heroImage || mobileHeroImage) && (
          <Box
            position="absolute"
            transform="translateZ(0)"
            bottom={0}
            left={0}
            width={1}
            height="100%"
          >
            {mobileHeroImage && mobileHeroImage.handle && (
              <MobileBanner image={mobileHeroImage} convert={convert} />
            )}

            <Banner
              image={heroImage}
              convert={convert}
              mobileImage={mobileHeroImage}
              data-qa-id="hero-image"
            />
          </Box>
        )}

        {(withOverlay || withLightOverlay) && (
          <Box
            position="absolute"
            transform="translateZ(0)"
            top={0}
            left={0}
            width={1}
            height="100%"
            bg={`rgba(0,0,0,${withLightOverlay ? 0.2 : 0.4})`}
          />
        )}
      </Box>

      <Box
        position="relative"
        transform="rotateZ(0)"
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        width="100%"
      >
        {children}
      </Box>
    </Box>
  );
}
